define("calendar/components/calendar/connect-social", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "later/utils/constants"], function (_exports, _component, _templateFactory, _component2, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"later/utils/constants"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @closable={{false}} class="tOB--connectWizard" as |modal|>
    <modal.card
      @portrait={{true}}
      class="tOB--connectWizard__card at--onboardingChecklist__connectWizard--de at--onboardingChecklist__connectWizard--fr"
      data-test-id="connect-social"
    >
      <modal.card-header class="u--p__b__0">
        <p class="o--modalHeader__title u--text--center">
          {{t "app.no_social_profiles_openCal"}}
        </p>
      </modal.card-header>
      <modal.card-body>
        <div class="u--row u--row--noCollapse u--m__b__sm">
          {{#each-in this.SOCIAL_PROFILE_CODES as |key value|}}
            <div class="u--col__6 u--m__t__xs" data-test-id="{{value}}-profile">
              <Shared::Social::ConnectProfile @area="social-connect-modal" @type={{value}} />
            </div>
          {{/each-in}}
        </div>
      </modal.card-body>
      <modal.card-footer class="tOB--connectWizard__cardFooter">
        <Shared::Ui::Button
          @onClick={{@close}}
          @text={{t "shared_words.dismiss"}}
          @variant="outline"
          class="u--float--left"
          data-test-id="dismiss-button"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "H3FeFROR",
    "block": "[[[8,[39,0],[[24,0,\"tOB--connectWizard\"]],[[\"@closable\"],[false]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[24,0,\"tOB--connectWizard__card at--onboardingChecklist__connectWizard--de at--onboardingChecklist__connectWizard--fr\"],[24,\"data-test-id\",\"connect-social\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"o--modalHeader__title u--text--center\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"app.no_social_profiles_openCal\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--row u--row--noCollapse u--m__b__sm\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[30,0,[\"SOCIAL_PROFILE_CODES\"]]],null],null,[[[1,\"          \"],[10,0],[14,0,\"u--col__6 u--m__t__xs\"],[15,\"data-test-id\",[29,[[30,2],\"-profile\"]]],[12],[1,\"\\n            \"],[8,[39,4],null,[[\"@area\",\"@type\"],[\"social-connect-modal\",[30,2]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[2,3]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-footer\"]],[[24,0,\"tOB--connectWizard__cardFooter\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,5],[[24,0,\"u--float--left\"],[24,\"data-test-id\",\"dismiss-button\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,4],[28,[37,1],[\"shared_words.dismiss\"],null],\"outline\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"value\",\"key\",\"@close\"],false,[\"shared/modal\",\"t\",\"each\",\"-each-in\",\"shared/social/connect-profile\",\"shared/ui/button\"]]",
    "moduleName": "calendar/components/calendar/connect-social.hbs",
    "isStrictMode": false
  });

  class ConnectSocialComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "SOCIAL_PROFILE_CODES", _constants.SOCIAL_PROFILE_CODES);
    }

  }

  _exports.default = ConnectSocialComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ConnectSocialComponent);
});